export default __webpack_public_path__ + "static/media/img2.ce13d64f.jpg";